// รหัสแผ่นบนกระดาษคำตอบ — บอกว่าแผ่นนี้เป็นของข้อสอบชุดไหน นักเรียนคนไหน (study_id)
//
// พิมพ์เป็นแถบช่องสี่เหลี่ยมทึบ/ว่าง ไม่ใช่ QR โดยตั้งใจ: ตัวอ่านกระดาษในขั้นถัดไปอ่านแถบนี้
// ด้วยโค้ดเดียวกับที่อ่านช่องฝนคำตอบ (จัดภาพตรงด้วยมุมสี่เหลี่ยม แล้ววัดความทึบของช่อง)
// ไม่ต้องมีตัวถอด QR อีกตัว และช่อง 4 มม. ทนรอยยับ/แสงไม่พอกว่าจุดของ QR ขนาดเท่ากันมาก
//
// 52 บิต = exam_id 20 บิต + study_id 24 บิต + CRC-8 อีก 8 บิต
// CRC มีไว้ให้ตัวอ่านรู้ตัวว่าอ่านผิด (นักเรียนเผลอขีดโดนช่อง) แทนที่จะเอาคะแนนไปลงคนอื่น
// — การลงคะแนนผิดคนเงียบๆ แย่กว่าการบอกว่าอ่านแผ่นนี้ไม่ได้มาก

export const EXAM_BITS = 20
export const STUDY_BITS = 24
export const CRC_BITS = 8
export const CODE_BITS = EXAM_BITS + STUDY_BITS + CRC_BITS

// กระดาษสำรอง (ไม่ได้ผูกกับนักเรียนคนไหน นักเรียนฝนเลขประจำตัวเอง) — ใส่ค่านี้แทน study_id
// study_id จริงไม่มีวันถึง 2^24-1 ตัวอ่านจึงรู้ได้จากแถบรหัสเดิมที่มี CRC ว่าแผ่นนี้เป็นกระดาษสำรอง
// ไม่ต้องเปลี่ยนผังหรือความยาวแถบ (LAYOUT_VERSION เดิม)
export const SPARE_STUDY_ID = 2 ** STUDY_BITS - 1

const toBits = (value, width) => {
  const bits = []
  for (let i = width - 1; i >= 0; i--) bits.push(Math.floor(value / 2 ** i) % 2)
  return bits
}

const fromBits = (bits) => bits.reduce((n, b) => n * 2 + (b ? 1 : 0), 0)

// CRC-8 (poly 0x07) ทีละบิต — payload ไม่ลงตัวเป็นไบต์จึงไม่ใช้ตารางไบต์
export const crc8 = (bits) => {
  let crc = 0
  for (const bit of bits) {
    const top = ((crc >> 7) & 1) ^ (bit ? 1 : 0)
    crc = (crc << 1) & 0xff
    if (top) crc ^= 0x07
  }
  return crc
}

// salt = ค่าที่ XOR กับ CRC ตามแบบกระดาษ (sheetLayout.codeSaltFor) — แยกแบบที่แถบรหัสอยู่ตำแหน่งเดียวกัน
// ถอดด้วย salt ผิดแบบ CRC ไม่ผ่านเสมอ (payload เดิม CRC ต่างกันด้วยค่าคงที่ที่ไม่ใช่ศูนย์)
export const encodeSheetCode = (examId, studyId, salt = 0) => {
  if (!Number.isInteger(examId) || examId < 1 || examId >= 2 ** EXAM_BITS) {
    throw new Error(`exam_id ${examId} ใส่ในรหัสแผ่นไม่ได้`)
  }
  if (!Number.isInteger(studyId) || studyId < 1 || studyId >= 2 ** STUDY_BITS) {
    throw new Error(`study_id ${studyId} ใส่ในรหัสแผ่นไม่ได้`)
  }
  const payload = [...toBits(examId, EXAM_BITS), ...toBits(studyId, STUDY_BITS)]
  return [...payload, ...toBits(crc8(payload) ^ salt, CRC_BITS)]
}

// คืน { examId, studyId } หรือ null เมื่อ CRC ไม่ผ่าน
export const decodeSheetCode = (bits, salt = 0) => {
  if (!Array.isArray(bits) || bits.length !== CODE_BITS) return null
  const payload = bits.slice(0, EXAM_BITS + STUDY_BITS)
  if ((crc8(payload) ^ salt) !== fromBits(bits.slice(EXAM_BITS + STUDY_BITS))) return null
  const examId = fromBits(payload.slice(0, EXAM_BITS))
  const studyId = fromBits(payload.slice(EXAM_BITS))
  if (!examId || !studyId) return null
  return { examId, studyId }
}

// ข้อความที่พิมพ์ใต้แถบ ให้คนอ่านเทียบได้เวลาตัวอ่านบอกว่าอ่านไม่ออก
export const sheetCodeText = (examId, studyId) => (
  studyId === SPARE_STUDY_ID ? `E${examId}-สำรอง` : `E${examId}-S${studyId}`
)
